module.exports = __webpack_public_path__ + "static/media/create_hub_prac.71ac6d49.svg";